import { render, staticRenderFns } from "./MainOrderContent.vue?vue&type=template&id=56019b26&scoped=true&"
import script from "./MainOrderContent.vue?vue&type=script&lang=js&"
export * from "./MainOrderContent.vue?vue&type=script&lang=js&"
import style0 from "./MainOrderContent.vue?vue&type=style&index=0&id=56019b26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56019b26",
  null
  
)

/* custom blocks */
import block0 from "./MainOrderContent.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports